"use client";

import { useAnalyticsTracker } from "@/hooks/useAnalyticsTracker";

export default function AnalyticsTracker() {
  useAnalyticsTracker();
  return null;
}
